import type { ExtensionDefinition } from '../types'
import { EtestingConfigSideAction } from './components/EtestingConfigSideAction'
import { etestingFields } from './fields'

export const etestingExtension: ExtensionDefinition = {
  id: 'etesting',
  name: 'e-testing',
  description: 'Évaluation des candidats par tests en ligne.',
  logo: '/etesting.png',
  enabledConfig: 'etesting.enabled',
  requiredConfigKeys: etestingFields.map((field) => field.config),
  ConfigSideAction: EtestingConfigSideAction
}
